import { createSelector } from 'reselect';
import { entitiesSelector } from './issue-selector.tsx';

export const jpdDeliverLinkTypeIdSelector = createSelector(
	entitiesSelector,
	(entities) => entities.jpdDeliveryIssueLinkTypeId,
);
